import { PRODUCT_SORT_VALUES } from '@src/quince-site-common/src/constants/product'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import { bffClient } from '@src/quince-site-common/src/utils/HttpClient'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { extractQueryParamFromPageLocation } from '@src/quince-site-integrated/src/utils'

import { DYNAMIC_FEEDS } from '../../collection.constants'

import { IProductFeedResponseForCollection } from './CollectionService.types'

class CollectionService {
  public async getNextPageProductFeed({
    slug,
    currentSlug,
    page = 0,
    nextFeedURL,
    filter = '',
    sortBy = PRODUCT_SORT_VALUES.FEATURED,
    baseSortBy,
    collectionType,
    productType,
  }: {
    slug: string
    page?: number
    filter?: string
    sortBy?: PRODUCT_SORT_VALUES | undefined
    baseSortBy: PRODUCT_SORT_VALUES | undefined
    collectionType: string
    currentSlug: string
    nextFeedURL?: string
    productType?: string
  }) {
    let email, lbUserId
    if (DYNAMIC_FEEDS.includes(slug)) {
      email =
        getCookie(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL) ?? getCookie(ANALYTIC_COOKIES.LB_CUSTOMER_TENTATIVE_EMAIL) ?? ''
      lbUserId = getlbUserId() ?? ''
    }

    const apiParamsForFilters = new URLSearchParams(filter)
    if (collectionType === 'trending') {
      const productId = isBrowser() && extractQueryParamFromPageLocation('productId')
      const productColor = isBrowser() && extractQueryParamFromPageLocation('productColor')

      const productColorPresentInURL = productColor && typeof productColor === 'string'

      if (productColorPresentInURL) {
        if (!apiParamsForFilters.get('colors')) {
          apiParamsForFilters.set('colors', productColor)
        } else {
          apiParamsForFilters.set('colors', `${apiParamsForFilters.get('colors')},${productColor}`)
        }
      }

      if (productId) {
        if (!apiParamsForFilters.get('productId')) {
          apiParamsForFilters.set('productId', productId)
        }
      }
    }

    if (['static', 'allNewArrivals'].includes(collectionType) && productType) {
      apiParamsForFilters.set('productType', encodeURIComponent(productType))
    }

    const { data } = await bffClient.get<IProductFeedResponseForCollection>('/v1/collection/get-products-feed', {
      params: {
        page,
        slug,
        currentSlug,
        filter: apiParamsForFilters.toString(),
        sortBy,
        baseSortBy,
        email,
        lbUserId,
        ...(['trendingThisWeek', 'pickedForYou'].includes(collectionType) ? { next_url: nextFeedURL } : {}),
      },
    })

    return data
  }
}

const collectionService = new CollectionService()

export default collectionService
